import { createAction, props } from '@ngrx/store';
import { DriverManagementDriversRequest, DriverManagementDriversResponse } from './driver-management-drivers.models';

export const loadDriverManagementDrivers = createAction(
  '[Driver Management Drivers] Load',
  props<{ request: DriverManagementDriversRequest; key: string }>(),
);

export const loadDriverManagementDriversSuccess = createAction(
  '[Driver Management Drivers] Load Success',
  props<{ key: string; response: DriverManagementDriversResponse }>(),
);

export const loadDriverManagementDriversFailure = createAction(
  '[Driver Management Drivers] Load Failure',
  props<{ key: string; error: string }>(),
);

export const clearDriverManagementDriversByKey = createAction(
  '[Driver Management Drivers] Clear By Key',
  props<{ key: string }>(),
);

export const clearDriverManagementDrivers = createAction('[Driver Management Drivers] Clear');
